import { render, staticRenderFns } from "./manage-name.vue?vue&type=template&id=269a0d6f&scoped=true"
import script from "./manage-name.vue?vue&type=script&lang=ts"
export * from "./manage-name.vue?vue&type=script&lang=ts"
import style0 from "./manage-name.vue?vue&type=style&index=0&id=269a0d6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269a0d6f",
  null
  
)

export default component.exports